export enum AnalogOutputMode {
	LowImpedance = 'LOW_IMPEDANCE',
	SeventyVolt = 'SEVENTY_VOLT'
}

export enum AnalogLogicPreset {
	ModeA = 'MODE_A',
	ModeB = 'MODE_B'
}
